// The address a logged-out visitor asked for, to bring them there once logged
// in. Nothing for the home address, the login pages (a reset-password link
// carries a token) and the page the browser extension loads in its frame.
export const getPendingPathFromUrl = (): string | null => {
  if (typeof window === 'undefined') return null
  const pathname = window.location?.pathname
  if (!pathname || pathname === '/') return null
  if (pathname.startsWith('/auth/') || pathname.startsWith('/index.html')) return null
  if (window.location.hash?.startsWith('#/extension/')) return null
  return pathname + (window.location.search ?? '')
}
